// extracted by mini-css-extract-plugin
module.exports = {"result-carousel":"style_result-carousel__2AQYY","media":"style_media__28x19","visibilityOffIcon":"style_visibilityOffIcon__2ETYD"};